import React from 'react';

/**
 * Holds the single, application-wide Statsig client along with its
 * readiness state. Provided by FeatureFlagsProvider and consumed through
 * the useFeatureFlags hook.
 *
 * A null value means no provider is mounted above the consumer.
 */
export const FeatureFlagsContext = React.createContext(null);

export default FeatureFlagsContext;
